module.exports = "div#main_form_registration {\r\n    background: #f9fafc;\r\n}"